import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../../Axios/AxiosInstance';
import { useLocation } from 'react-router-dom';
import Header from '../../../Components/Header/Header';
import Footer from '../../../Components/Footer/Footer';
import { TableTextConstants, TextConstants } from '../../../Constants/Constants';
import ReusableTable from '../../../Components/Table/ReusableTable';

const Painter = () => {
  const { dealerId } = useParams();
  const location = useLocation();
  const { scannedDate, dealerName, dealerCode } = location.state || {};
  const [dealerData, setDealerData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); 
  const [isLoading, setIsLoading] = useState(true); 
  const [totalRecords, setTotalRecords] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]); 
  const pageDataRef = useRef({});


  const navigate = useNavigate();

  const convertDateFormat = (dateStr) => {
    if (!dateStr) return '';

    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  };

  const formattedDate = convertDateFormat(scannedDate);

  useEffect(() => {
    fetchDealerData();
  }, [dealerId, rowsPerPage, currentPage]);
  
  const fetchDealerData = async () => {
    const cacheKey = `${currentPage}-${rowsPerPage}`;
    if (pageDataRef.current[cacheKey]) {
      setDealerData(pageDataRef.current[cacheKey]);
    } else {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post('admindashboard/DashBordDataListByDealer', {
          fromDate: formattedDate,
          toDate: formattedDate,
          dealerId: parseInt(dealerId, 10),
          painterId: 0,
          searchItem: "",
          pageNumber: currentPage,
          pageSize: rowsPerPage,
        });
  
        const { dataListByDealerList, paginatedData } = response.data;
  
        if (dataListByDealerList && Array.isArray(dataListByDealerList)) {
          const formattedData = dataListByDealerList.map(item => {
            const formattedScannedDate = item.scannedDate ? new Date(item.scannedDate).toLocaleDateString('en-GB') : 'N/A';
            return {
              scannedDate: formattedScannedDate,
              painterName: item.painterName,
              painterId: item.painterId,
              painterMobile: item.painterMobile,
              totalAmount: item.totalAmount,
              handlingCharges: item.handlingCharges,
              totalFinalAmount: item.totalFinalAmount,
            };
          });
          setDealerData(formattedData);
          setTotalRecords(paginatedData.totalRecords);
          pageDataRef.current[cacheKey] = formattedData;
        } else {
          console.error('Data format is incorrect or missing:', dataListByDealerList);
        }
      } catch (error) {
        console.error('Error fetching dealer data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  

  const columns = [
    { key: "scannedDate", label: "Date" },
    { key: "painterName", label: "Painter Name" },
    { key: "painterMobile", label: "Painter Mobile" },
    { key: "totalAmount", label: "Amount", isTextAlignRight: true, isCurrency: true },
    { key: "handlingCharges", label: "Handling Fee", isTextAlignRight: true, isCurrency: true },
    { key: "totalFinalAmount", label: "Total Amount", isTextAlignRight: true, isCurrency: true },
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows); 
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);  
    setCurrentPage(1); 
  };

  const handleEyeClick = (row) => {
    const { painterId, scannedDate, painterName, painterMobile } = row;
    navigate(`/painter-flow/${dealerId}/${painterId}`, { state: { scannedDate, painterName, painterMobile } });
  };
 
  

  return (
    <div className="flex flex-col min-h-screen">
    <Header title="Painter Details" />

    <div className="flex flex-col flex-1 mx-2 my-3">
      <div className="flex justify-between">
        <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
          <span className="text-md">
            {TableTextConstants.dealerName}: {dealerName}
          </span>
        </div>
        <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
          <span className="text-md">
            {TableTextConstants.dealerCode}: {dealerCode}
          </span>
        </div>
      </div>
        <div className="mt-3 p-1">
          <ReusableTable
            data={dealerData}
            columns={columns}
            rowsPerPage={rowsPerPage}
            loading={isLoading}
            currentPage={currentPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSelectedRowsChange={handleSelectedRowsChange}
            // enableCheckbox={true}
            enableEye={true}
            onEyeClick={handleEyeClick}
          />
        </div>
    </div>

    

    <Footer />
  </div>
  
  
  );
};

export default Painter;
